/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const UserProfile = ({ currentUser, editProfile, load, success }) => {
  const [profile, setProfile] = useState(currentUser);

  useEffect(() => {
    setProfile(currentUser);
  }, [currentUser]);

  const onChange = (e) => {
    const { name, value } = e.target;

    setProfile({
      ...profile,
      [name]: value,
    });
  };

  const {
    address,
    alternatePhoneNumber,
    firstName,
    email,
    lastName,
    phoneNumber,
  } = profile;

  const updateProfile = (user, id) => {
    editProfile(user, id);
  };

  if (success) {
    toast.success('Edited Successfully!');
  }

  return (
    <div
      className="tab-pane show active mt-3"
      id="nav-profile"
      role="tabpanel"
      aria-labelledby="nav-profile-tab"
    >
      <ToastContainer />

      <div className="form-horizontal col-md-12 p-0">
        <div className="form-group col-12 col-md-12 d-flex p-0 flex-wrap">
          <div className="col-md-6 col-12 mb-3">
            <label htmlFor="">First Name</label>
            <input
              type="text"
              placeholder="First Name"
              name="firstName"
              className="form-control form_box"
              value={firstName}
              onChange={onChange}
            />
          </div>

          <div className="col-md-6 col-12 mb-3">
            <label htmlFor="">Last Name</label>
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              className="form-control form_box"
              value={lastName}
              onChange={onChange}
            />
          </div>
        </div>

        <div className="form-group col-12 col-md-12 d-flex p-0 flex-wrap">
          <div className="col-md-6 col-12 mb-3">
            <label htmlFor="">Phone Number 1</label>
            <input
              type="text"
              placeholder="Phone Number"
              className="form-control form_box"
              value={phoneNumber}
              readOnly
            />
          </div>

          <div className="col-md-6 col-12 mb-3">
            <label htmlFor="">Phone Number 2</label>
            <input
              type="text"
              placeholder="Phone Number 2"
              className="form-control form_box"
              value={alternatePhoneNumber}
              onChange={onChange}
              name="alternatePhoneNumber"
            />
          </div>
        </div>

        <div className="form-group col-12 col-md-12 d-flex p-0 flex-wrap">
          <div className="col-md-6 col-12 mb-3">
            <label htmlFor="">Email Address</label>
            <input
              type="text"
              placeholder="Email Address"
              className="form-control form_box"
              value={email}
              readOnly
            />
          </div>

          <div className="col-md-6 col-12 mb-3">
            <label htmlFor="">Physical Address</label>
            <input
              type="text"
              placeholder="Physical Address"
              className="form-control form_box"
              value={address}
              onChange={onChange}
              name="address"
            />
          </div>
        </div>

        <div className="form-group col-12">
          {load ? (
            <button
              className="btn btn-grey w-100 mb-5"
              onClick={() => updateProfile(profile, profile.id)}
              disabled={load}
            >
              Updating Profile
            </button>
          ) : (
            <button
              className="btn btn-grey w-100"
              onClick={() => updateProfile(profile, profile.id)}
            >
              UPDATE PROFILE
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

UserProfile.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  currentUser: PropTypes.object.isRequired,
  editProfile: PropTypes.func.isRequired,
  load: PropTypes.bool.isRequired,
  success: PropTypes.bool.isRequired,
};

export default UserProfile;
